import { render, staticRenderFns } from "./ContactSectionCelular.vue?vue&type=template&id=21d1979c&scoped=true&"
import script from "./ContactSectionCelular.vue?vue&type=script&lang=js&"
export * from "./ContactSectionCelular.vue?vue&type=script&lang=js&"
import style0 from "./ContactSectionCelular.vue?vue&type=style&index=0&id=21d1979c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1979c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VImg,VRow,VSnackbar})
